<div id="drug-page-grid">
  <div nz-row nzType="flex">
    <div nz-col nzSpan="24">
      <div class="drug-page-grid-container">
        <table
          #table
          mat-table
          [dataSource]="dataSource"
          class="drug-grid"
          matSort
        >
          <!-- Name Column -->
          <ng-container matColumnDef="name" sticky>
            <th mat-header-cell *matHeaderCellDef></th>
            <td
              mat-cell
              *matCellDef="let element"
              [title]="element.name"
              [ngClass]="{
                'cell-bold': element.doBold === true
              }"
            >
              {{ element.name }}
              <nz-tag
                *ngIf="element.exclude"
                [nzColor]="'#E9EBEE'"
                class="excluded"
                >Ex</nz-tag
              >
              <span
                class="dsm-icon"
                *ngIf="element.isResearchIconShow && tableName != 'Broker'"
              >
                <va-icon
                  (click)="getDSMDOcumentDetails()"
                  isFontAwesome="true"
                  class=""
                  [name]="book"
                ></va-icon>
              </span>
            </td>
          </ng-container>

          <!-- Broker Name Column -->
          <ng-container matColumnDef="broker" sticky>
            <th
              class="pointer-header"
              mat-header-cell
              *matHeaderCellDef
              style="cursor: pointer"
              (click)="sortData('broker')"
              [ngClass]="{ 'broker-pos': showPOS }"
            >
              <span>Broker</span>
              <span *ngIf="tableName == 'Broker'">
                <span
                  style="
                    position: absolute;
                    right: 6px;
                    top: 7px;
                    font-size: 12px;
                  "
                >
                  <va-icon
                    size="small"
                    isFontAwesome="true"
                    [name]="faSortUp"
                    [ngStyle]="{
                      color:
                        activeSort === 'broker' && sortDirection === 'asc'
                          ? '#36abad'
                          : 'lightgray'
                    }"
                  >
                  </va-icon>
                </span>
                <span
                  style="
                    position: absolute;
                    right: 6px;
                    top: 8px;
                    font-size: 12px;
                  "
                >
                  <va-icon
                    size="small"
                    isFontAwesome="true"
                    [name]="faSortDown"
                    [ngStyle]="{
                      color:
                        activeSort === 'broker' && sortDirection === 'desc'
                          ? '#36abad'
                          : 'lightgray'
                    }"
                  >
                  </va-icon>
                </span>
              </span>
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              [title]="element.exclude ? element.name + '(Ex)' : element.name"
              [ngClass]="{
                'cell-bold': element.doBold === true,
                'broker-pos': showPOS
              }"
            >
              <span>
                {{ element.name }}
              </span>
              <nz-tag
                *ngIf="element.exclude"
                [nzColor]="'#E9EBEE'"
                class="excluded"
                >Ex</nz-tag
              >
              <span
                class="dsm-icon"
                *ngIf="element.isResearchIconShow && tableName == 'Broker'"
              >
                <va-icon
                  (click)="getDSMDOcumentDetailsByBroker(element.src)"
                  isFontAwesome="true"
                  class=""
                  [name]="book"
                ></va-icon>
              </span>
            </td>
          </ng-container>

          <!-- Date Published Column -->
          <ng-container
            matColumnDef="date_published"
            sticky
            class="date-column"
          >
            <th
              class="pointer-header"
              (click)="sortData('date_published')"
              mat-header-cell
              *matHeaderCellDef
              [ngClass]="{ 'date_published-pos': showPOS }"
            >
              <span>Date Published</span>
              <span *ngIf="tableName == 'Broker'">
                <span
                  style="
                    position: absolute;
                    right: 6px;
                    top: 7px;
                    font-size: 12px;
                  "
                >
                  <va-icon
                    size="small"
                    isFontAwesome="true"
                    [name]="faSortUp"
                    [ngStyle]="{
                      color:
                        activeSort === 'date_published' &&
                        sortDirection === 'asc'
                          ? '#36abad'
                          : 'lightgray'
                    }"
                  >
                  </va-icon>
                </span>
                <span
                  style="
                    position: absolute;
                    right: 6px;
                    top: 8px;
                    font-size: 12px;
                  "
                >
                  <va-icon
                    size="small"
                    isFontAwesome="true"
                    [name]="faSortDown"
                    [ngStyle]="{
                      color:
                        activeSort === 'date_published' &&
                        sortDirection === 'desc'
                          ? '#36abad'
                          : 'lightgray'
                    }"
                  >
                  </va-icon>
                </span>
              </span>
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              [ngClass]="{ 'date_published-pos': showPOS }"
              [title]="element.date_published"
            >
              {{ element.date_published ? element.date_published : "-" }}
              <va-icon
                *ngIf="element.reaffirmTrue"
                size="small"
                class="reaffirm-icon"
                name="republish"
                nz-popover
                [nzPopoverTitle]="reaffirmTitle"
                [nzPopoverContent]="reaffirmTemplate"
                nzPopoverTrigger="hover"
                nzPopoverPlacement="right"
                nzPopoverWidth="20px"
                nzOverlayClassName="reaffirm-popover"
              >
              </va-icon>
              <ng-template #reaffirmTitle>
                <span>
                  <b>Reaffirmed </b>
                </span>
              </ng-template>
              <ng-template #reaffirmTemplate>
                <span *ngIf="element.reaffirmType == 0">
                  This model is reincluded in consensus because the broker
                  republished the model on:{{
                    element.reaffirmDate | date: "dd MMM yyyy"
                  }}
                </span>
                <span *ngIf="element.reaffirmType == 1">
                  This model is reincluded in consensus because the broker
                  reaffirmed it on:
                  {{ element.reaffirmDate | date: "dd MMM yyyy" }}
                </span>

                <span>
                  <br />
                  <a [href]="reaffirmed_in_consensus" target="_blank">
                    Learn More
                  </a>
                </span>
              </ng-template>
            </td>
          </ng-container>

          <!-- pos Column -->
          <ng-container matColumnDef="pos" sticky>
            <th mat-header-cell *matHeaderCellDef>POS</th>
            <td
              mat-cell
              *matCellDef="let element"
              (click)="loadFormulaBar(element, '', true)"
              [ngClass]="{
                'cell-negative': element.pos?.toString().includes('(')
              }"
              [title]="element.pos"
            >
              {{ element.pos }}
            </td>
          </ng-container>

          <!-- unit Column -->
          <ng-container matColumnDef="unit" sticky class="unit-column">
            <th mat-header-cell *matHeaderCellDef>Unit</th>
            <td mat-cell *matCellDef="let element">
              {{
                dataSettings.view_by[0] !== "yoy"
                  ? element.meta && element.meta.unit == "Amount"
                    ? element.meta.currency + element.meta.magnitude
                    : element.meta && element.meta.unit !== "%"
                      ? element.meta.unit + element.meta.magnitude
                      : ""
                  : element.unit
              }}
            </td>
          </ng-container>

          <!-- period Column -->
          <ng-container *ngFor="let colKey of periodList">
            <ng-container [matColumnDef]="colKey + ''">
              <th
                (click)="sortData(colKey)"
                mat-header-cell
                *matHeaderCellDef
                class="period"
                [ngClass]="tableName == 'Broker' ? 'pointer-header' : ''"
              >
                {{ forecastPeriodData[colKey] ? colKey + "E" : colKey }}
                <span *ngIf="tableName == 'Broker'">
                  <span
                    style="
                      position: absolute;
                      right: 6px;
                      top: 7px;
                      font-size: 12px;
                    "
                  >
                    <va-icon
                      size="small"
                      isFontAwesome="true"
                      [name]="faSortUp"
                      [ngStyle]="{
                        color:
                          activeSort === colKey && sortDirection === 'asc'
                            ? '#36abad'
                            : 'lightgray'
                      }"
                    >
                    </va-icon>
                  </span>
                  <span
                    style="
                      position: absolute;
                      right: 6px;
                      top: 8px;
                      font-size: 12px;
                    "
                  >
                    <va-icon
                      size="small"
                      isFontAwesome="true"
                      [name]="faSortDown"
                      [ngStyle]="{
                        color:
                          activeSort === colKey && sortDirection === 'desc'
                            ? '#36abad'
                            : 'lightgray'
                      }"
                    >
                    </va-icon>
                  </span>
                </span>
              </th>

              <td
                mat-cell
                *matCellDef="let element"
                class="cell-numeric-value-alignment"
                (click)="loadFormulaBar(element, colKey)"
                [ngClass]="{
                  'cell-selected': selectedCell === element.id + '|' + colKey
                }"
                [style.backgroundColor]="
                  brokerHighLowEnable
                    ? element.period[colKey]['high_low_color']
                    : ''
                "
              >
                <span
                  class="cell-value"
                  [ngClass]="{
                    'cell-negative': element.period[colKey]['value']
                      ?.toString()
                      .includes('(')
                  }"
                >
                  {{
                    element.period[colKey]["value"] !== null &&
                    element.period[colKey]["value"] !== undefined
                      ? element.period[colKey]["value"]
                      : "-"
                  }}
                </span>
              </td>
            </ng-container>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayColumns; sticky: true"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayColumns"
            [ngClass]="{
              'row-selected': row.id === selectedRow
            }"
          ></tr>
        </table>
      </div>
    </div>
  </div>
</div>
